import { FC, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUser } from '@clerk/clerk-react'
import { toast } from 'sonner'

// COMPONENTS
import * as Icons from '@icons'
import { Column } from '@components/templates/column'
import Button from '@/components/atoms/button'
import AddToWalletButton from '@components/atoms/add-to-wallet-button'
import MyCardDetails from '@/components/organisims/my-card-details'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { parseTeraUserData } from '@schemas'
import { getReferralId } from '@utils/referral-storage'

const Component: FC<{}> = () => {
    const { user } = useUser()
    const [isCardReady, setIsCardReady] = useState(false)

    const { virtualCard } = useMemo(() => parseTeraUserData(user?.publicMetadata.tera), [user?.publicMetadata.tera])
    const navigate = useNavigate()

    async function handleComplete() {
        const referralId = await getReferralId()
        // navigate('/account', { state: { showExplainer: true } })
        navigate(referralId ? '/group' : '/account')
    }

    return (<>
        <Column.Content>
            <div className="flex flex-col items-center gap-4" style={{ textAlign: 'center', marginBottom: '1rem' }}>
                {!isCardReady ? (<>
                    <h2>Your Reloadable Card is Being Created... </h2>
                </>) : (<>
                    <div className="bubble-md flex items-center justify-center" style={{ alignSelf: 'center', background: 'var(--splitcard-green-600)', boxShadow: 'var(--box-shadow)' }}>
                        <Icons.CheckSmall tint="var(--splitcard-white)" width="5em" height="5em" />
                    </div>
                    <h2 style={{ color: 'var(--splitcard-green-600)' }}>Your Reloadable Card is Ready!</h2>
                </>)}
            </div>
            <MyCardDetails
                cardId={virtualCard?.id}
                cardHolder={user}
                lastFour={virtualCard?.lastFour}
                reloadable={true}
                handleCopy={() => toast.success('Card number copied')}
                onCardReady={() => setIsCardReady(true)}
            />
            <AddToWalletButton
                className='!mt-8'
                returnUrl='/sign-up/reloadable-card'
                disabled={!isCardReady}
            />
            <p className='text-body text-gray-500 text-center !px-4'>
                When linked to a group, the funds are instantly available on this card. Use it with Apple Pay or copy the numbers for online purchases.
            </p>
        </Column.Content>
        <Column.Footer>
            <Button style={{ whiteSpace: 'nowrap' }} theme="primary" onClick={handleComplete}>Complete</Button>
        </Column.Footer>
    </>)
}

const ReloadableCardRoute: RouteObject = {
    path: "reloadable-card",
    Component,
}

export default ReloadableCardRoute
